import { useRouter } from 'next/router';

import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { LearningInformation, PatternList } from './style';

import { PatternItem } from '@components/molecules/academicLandingPage/patternItem';
import { useUniversityInformation } from '@helpers/use';

export const LearningInformationSection = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const universityIdName = router.query.universityIdName as string;
  const { landingPage } = useUniversityInformation(universityIdName);

  return (
    <LearningInformation>
      <Typography
        variant="h4"
        marginBottom={1}
        textAlign="center"
        fontSize={{ xs: 22, sm: 24 }}
        lineHeight={1}
        fontWeight={500}
        color="#00000099"
      >
        {t('academic_landing_page.learning_information_section.heading')}
      </Typography>
      <Typography
        variant="h4"
        marginBottom={6}
        textAlign="center"
        fontSize={{ xs: 24, md: 30 }}
        lineHeight={{ xs: '24px', md: '34px' }}
        fontWeight={700}
        color="#000000de"
      >
        {landingPage?.learningInformationSectionHeading || ''}
      </Typography>
      <PatternList>
        {landingPage?.universityLearningInformations?.length &&
          landingPage?.universityLearningInformations.map((item, index) => (
            <PatternItem
              key={`Learning Information ${item.title}`}
              index={item.position}
              title={item.title}
              description={item.description}
              imageUrl={item.imageUrl}
            />
          ))}
      </PatternList>
    </LearningInformation>
  );
};
